import { Component } from "preact";
import Uppy from "@uppy/core";
import AwsS3 from "@uppy/aws-s3";
import { DashboardModal } from "@uppy/react";
import "./styles/uppy.min.scss";
import "./styles/FileUploader.scss";
import { uploadFileAPI } from "../../api";
import uuid from "../uuid";

class FileUploader extends Component {
  constructor(props) {
    super(props);
    this.uppy;
    this.state = {
      isFileUploaderOpen: false,
      focusTarget: null,
    };
    this.initializeUppy();
  }

  componentWillUnmount() {
    this.uppy && this.uppy.close();
    const [uppyClasses] = document.getElementsByClassName(
      "uppy-Dashboard-isFixed"
    );
    if (uppyClasses) uppyClasses.classList.remove("uppy-Dashboard-isFixed");
  }

  focusToTarget = () => {
    if (this.state.focusTarget) {
      this.state.focusTarget.focus();
      this.setState({
        focusTarget: null,
      });
    }
  };

  handleClose = () => {
    this.uppy && this.uppy.close();
    this.focusToTarget();
    this.setState({
      isFileUploaderOpen: false,
    });
  };

  initializeUppy = () => {
    this.uppy = new Uppy({
      allowMultipleUploads: false,
    });
    const {
      clusterId,
      hubId, // hubId is prioritized if both clusterId and hubId passed to component
      access,
      region,
      resourceType,
      trigger,
      onFileUpload,
      payload,
    } = this.props;

    const isPublic = access === "public" ? true : false;
    let { type = "any" } = this.props;
    const restrictions = this.getFileRestrictions(type);
    const defaultOptions = {
      timeout: 1000 * 60 * 60,
      restrictions: { ...restrictions },
      autoProceed: true,
    };

    this.uppy.setOptions({ ...defaultOptions });

    this.uppy.use(AwsS3, {
      id: `AwsS3-${trigger}-${uuid()}`,
      async getUploadParameters(file) {
        const params = {
          filename: file.name,
          contentType: file.type,
          cluster: clusterId,
          hub: hubId,
          isPublic: isPublic,
          region: region,
          type: resourceType,
          location: "gcs",
          container: "pg-support-files",
          fileSize: file.size,
        };
        const data = await uploadFileAPI({
          body: params,
          payload: payload,
        });
        // console.log({ data, payload, params });
        return data;
      },
    });

    this.uppy.on("upload-success", (file, response) => {
      onFileUpload({
        filesUploaded: [{ key: file.id, file, url: response.uploadURL }],
      });
    });
  };

  toggleUploadModal = () => {
    const { isFileUploaderOpen } = this.state;
    this.setState({
      isFileUploaderOpen: !isFileUploaderOpen,
    });
    this.focusToTarget();
  };

  /** @type {JSX.MouseEventHandler} */
  showPicker = (e) => {
    this.uppy && this.uppy.close();
    // let { type = "any" } = this.props;
    this.initializeUppy();
    this.setState({ isFileUploaderOpen: true, focusTarget: e.target });
  };

  /** @type {JSX.KeyboardEventHandler} */
  handleKeyDown = (e) => {
    if (e.key === "Escape") {
      e.stopPropagation();
    }
  };

  getFileRestrictions = (type) => {
    let restrictions = {};
    restrictions["maxNumberOfFiles"] = 10;
    switch (type) {
      case "resume":
      case "doc":
        restrictions["allowedFileTypes"] = [".pdf", ".doc", ".docx"];
        restrictions["maxFileSize"] = 10 * 1024 * 1024; // 10MB

        break;
      case "thumbnail":
      case "image":
        restrictions["allowedFileTypes"] = ["image/*"];
        break;
      case "media":
        restrictions["allowedFileTypes"] = [".pdf", ".doc", ".docx", "image/*"];
        restrictions["maxFileSize"] = 50 * 1024 * 1024;
        break;
      case "profile-photo":
        restrictions["allowedFileTypes"] = ["image/*"];
        break;
      case "audio":
        restrictions["allowedFileTypes"] = [".mp3", ".wav"];
        break;
      case "any":
        // No restrictions
        break;
      default:
        break;
    }
    return restrictions;
  };

  render() {
    const { isFileUploaderOpen } = this.state;

    return (
      <div>
        {this.props.render({ onPick: this.showPicker })}
        <div onKeyDown={this.handleKeyDown}>
          <DashboardModal
            onKeyDown={this.handleKeyDown}
            uppy={this.uppy}
            open={isFileUploaderOpen}
            onRequestClose={this.handleClose}
            proudlyDisplayPoweredByUppy={false}
            animateOpenClose={false}
          />
        </div>
      </div>
    );
  }
}

export default FileUploader;



// WEBPACK FOOTER //
// ./utils/FileUploader/index.js